import React from 'react';
import Star from '@lt/components/icons-react/userflow/Star';
import styles from './hotelCardStars.module.css';

type HotelCardStarsProps = {
  value: 0 | 1 | 2 | 3 | 4 | 5;
};

const HotelCardStars: React.FC<HotelCardStarsProps> = ({ value }) => {
  if (!value) return null;

  const starsArr = Array.from({ length: value }, (_, index) => index);

  return (
    <>
      <meta itemProp="ratingValue" content={String(value)} />
      <div
        className={styles.starsContainer}
        itemProp="ratingValue"
        content={String(value)}
      >
        {starsArr.map((el) => (
          <Star key={el} className={styles.starIcon} />
        ))}
      </div>
    </>
  );
};

export default HotelCardStars;
